// Mirrors ChatbotPathVisibility.isQueryOrFragmentOnly in the backend: input such as #/checkout or
// /?ref=x would be saved as the root path and match every page.
export default function isQueryOrFragmentOnly(raw: string): boolean {
  const path = raw.trim();
  const pathPart = path.split(/[?#]/)[0];
  return pathPart !== path && /^\/*$/.test(pathPart);
}
